import React, { useState } from 'react';
import YoutubeEmbed, { getYoutubeId } from './YoutubeEmbed';
import VimeoEmbed from './VimeoEmbed';

export default function AccordionBlock(props) {
    const { data } = props;
    const items = data.videoLinks;

    const [activeVideo, setActiveVideo] = useState(0);

    return (
        <div>
            <div className="w-full">
                {items[activeVideo] && items[activeVideo].videoLink.includes('youtu') && (
                    <YoutubeEmbed controls id={getYoutubeId(items[activeVideo].videoLink)} />
                )}

                {items[activeVideo] && items[activeVideo].videoLink.includes('vim') && (
                    <VimeoEmbed controls url={items[activeVideo].videoLink} />
                )}
            </div>

            <div className="grid grid--videos gap-[16px]">
                {items?.map((item, i) => {
                    if (!item.videoLink || i === activeVideo) return null;

                    if (item.videoLink.includes('youtu')) {
                        const id = getYoutubeId(item.videoLink);
                        return (
                            <button
                                type="button"
                                onClick={() => setActiveVideo(i)}
                                className="cursor-pointer">
                                <YoutubeEmbed
                                    id={id}
                                    controls={false}
                                    className="pointer-events-none"
                                />
                            </button>
                        );
                    }
                    if (item.videoLink.includes('vim')) {
                        return (
                            <button
                                type="button"
                                onClick={() => setActiveVideo(i)}
                                className="cursor-pointer">
                                <VimeoEmbed
                                    controls={false}
                                    url={item.videoLink}
                                    className="pointer-events-none"
                                />
                            </button>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
}
